import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconSet from '../../../../../CMSComponent/icon'
import moment from 'moment'
import { faCalendarAlt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const checkCurrentUserMessage = (sender_id, current_user_id, ticker_user_id) => {
  if (current_user_id === ticker_user_id) {
    if (sender_id === current_user_id) {
      return true
    } else {
      return false
    }
  } else {
    if (sender_id === ticker_user_id) {
      return false
    } else {
      return true
    }
  }
}

const TicketChatListing = ({ chats, ticketDetails }) => {
  const currentUserData = useSelector((state) => state.User.user)
  const [showImage, setShowImage] = useState(false)

  let selectedUserId = null
  const currentImageUrl = useRef(null)
  return (
    <div>
      <div className='chat-wrapper' style={{ maxHeight: 'calc(100vh - 20rem)', overflow: 'auto', height: '70%', minHeight: '30rem' }}>
        {chats?.map((item, index) => {
          let currentUserMessage = checkCurrentUserMessage(item?.sender_id, currentUserData?.id, ticketDetails?.ticket?.user_id)
          if (item?.sender_type === 'ticket_reopen' || item?.sender_type === 'ticket_closed') {
            return (
              <div className='d-flex align-items-center justify-content-center my-2 mx-5' style={{ opacity: 0.5 }}>
                <hr style={{ flex: 1 }}></hr>
                <div className='subtitle1 mx-3'>{item?.message}</div>
                <hr style={{ flex: 1 }}></hr>
              </div>
            )
          }

          if (currentUserMessage) {
            return (
              <div className='chat-box-wrapper'>
                <div>
                  {selectedUserId?.profile ? (
                    <div className='avatar-icon-wrapper mr1'>
                      <div className='avatar-icon avatar-icon-xl rounded'>
                        <img width={82} src={selectedUserId?.profile} alt='' />
                      </div>
                    </div>
                  ) : (
                    <div className='avatar-icon-wrapper mr-2'>
                      <IconSet icon={'fa-regular fa-circle-user'} style={{ fontSize: '2rem', color: 'info', fontWeight: '300' }} color='info' />
                    </div>
                  )}
                </div>
                <div>
                  <div className='chat-box subtitle1'>
                    {item?.attachment && (
                      <div>
                        <img
                          className='cursor-pointer'
                          src={item?.attachment}
                          style={{ width: '20rem', maxHeight: '20rem' }}
                          onClick={() => {
                            currentImageUrl.current = item?.attachment
                            setShowImage(true)
                          }}></img>
                      </div>
                    )}

                    <div className='mt-2'> {item?.message}</div>
                  </div>
                  {item?.created_at && (
                    <small className='opacity-6' style={{ display: 'flex', alignItems: 'center' }}>
                      <FontAwesomeIcon icon={faCalendarAlt} className='mr-1' />
                      {moment(item?.created_at).format('HH:MM Do MMM, YYYY')}
                    </small>
                  )}
                </div>
              </div>
            )
          } else {
            return (
              <div className='chat-box-wrapper' style={{ flexDirection: 'row-reverse' }}>
                <div className='chat-box-wrapper chat-box-wrapper-right'>
                  <div>
                    <div className='chat-box subtitle1'>
                      {item?.attachment && (
                        <div>
                          <img
                            src={item?.attachment}
                            className='cursor-pointer'
                            style={{ width: '20rem', maxHeight: '20rem' }}
                            onClick={() => {
                              currentImageUrl.current = item?.attachment
                              setShowImage(true)
                            }}></img>
                        </div>
                      )}
                      <div className='mt-2'> {item?.message}</div>
                    </div>
                    {item?.created_at && (
                      <small className='opacity-6' style={{ display: 'flex', alignItems: 'center' }}>
                        <FontAwesomeIcon icon={faCalendarAlt} className='mr-1' />
                        {moment(item?.created_at).format('HH:MM Do MMM, YYYY')}

                        {/* <FontAwesomeIcon
                          icon={faTrash}
                          className='mr-1'
                          style={{ color: 'red', marginLeft: '1rem', cursor: 'pointer' }}
                          // onClick={() => onDeleteMessage(item?.id)}
                        /> */}
                      </small>
                    )}
                  </div>
                  <div>
                    <div className='avatar-icon-wrapper ml-1'>
                      {currentUserData?.photo ? (
                        <>
                          <div className='badge badge-bottom btn-shine badge-success badge-dot badge-dot-lg' />
                          <div className='avatar-icon avatar-icon-lg rounded'>{/* <img src={APP_URL + currentUserData?.photo} alt='' /> */}</div>
                        </>
                      ) : (
                        <div className='avatar-icon-wrapper mr-2'>
                          <IconSet icon={'fa-regular fa-circle-user'} style={{ fontSize: '2rem', color: 'info', fontWeight: '300' }} color='info' />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })}
        <Modal
          isOpen={showImage}
          toggle={() => {
            setShowImage(false)
            currentImageUrl.current = null
          }}
          centered={true}
          style={{ maxWidth: '90vw', width: 'auto' }}>
          <ModalHeader
            toggle={() => {
              setShowImage(false)
              currentImageUrl.current = null
            }}>
            Preview
          </ModalHeader>
          <ModalBody>
            <div className='d-flex justify-content-center align-items-center'>
              <img src={currentImageUrl.current} style={{ maxWidth: '100%', maxHeight: '80vh' }} alt='Chat Attachment' />
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  )
}

export default TicketChatListing
